import React from "react";

import {
    FiBookOpen,
    FiUsers,
} from "react-icons/fi";

/*
|--------------------------------------------------------------------------
| TAB CONSTANTS
|--------------------------------------------------------------------------
*/

export const LEDGER_TABS = {
    ALL:
        "ALL",

    CUSTOMERS:
        "CUSTOMERS",
};

/*
|--------------------------------------------------------------------------
| COMPONENT
|--------------------------------------------------------------------------
*/

const LedgerTabs = ({
    activeTab,
    onChange,
    transactionCount = 0,
    customerCount = 0,
}) => {
    return (
        <nav className="customer-ledger-tabs">
            <button
                type="button"
                className={
                    activeTab ===
                    LEDGER_TABS.ALL
                        ? "customer-ledger-tab customer-ledger-tab-active"
                        : "customer-ledger-tab"
                }
                onClick={() =>
                    onChange?.(
                        LEDGER_TABS.ALL
                    )
                }
            >
                <FiBookOpen />

                <span>
                    All Entries
                </span>

                <small>
                    {transactionCount}
                </small>
            </button>

            <button
                type="button"
                className={
                    activeTab ===
                    LEDGER_TABS.CUSTOMERS
                        ? "customer-ledger-tab customer-ledger-tab-active"
                        : "customer-ledger-tab"
                }
                onClick={() =>
                    onChange?.(
                        LEDGER_TABS.CUSTOMERS
                    )
                }
            >
                <FiUsers />

                <span>
                    Customer Wise
                </span>

                <small>
                    {customerCount}
                </small>
            </button>
        </nav>
    );
};

export default LedgerTabs;